import { Button, Tag, Tooltip, Avatar, Space, Switch } from "antd"
import { GetCityWithSection } from "hooks/returnCityName"
import EngHistoryEdit from "./EngHistoryEdit"
import NumberFormat from "react-number-format"
import { UserFiles } from "./user-files"
import {
  EditOutlined,
  UserOutlined,
  IdcardOutlined,
  PhoneOutlined,
  BankOutlined,
  EnvironmentOutlined,
  CalendarOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  SafetyCertificateOutlined,
} from "@ant-design/icons"

const renderEditEngHistoryButton = (params, { props }) => (
  <EngHistoryEdit
    mainRowData={params}
    rowData={params.engineerHistoryViewModel}
    mainProps={props}
  />
)

const renderEditButton = (params, { props, handleEdit }) => (
  <Tooltip title="ویرایش مهندس">
    <Button
      type="primary"
      ghost
      size="small"
      icon={<EditOutlined />}
      onClick={() => handleEdit(params)}
      style={{ borderRadius: 6 }}
    />
  </Tooltip>
)

const renderFileButton = (params, { props }) => (
  <UserFiles rowData={params} mainProps={props} />
)

export const columns = ({ props, handleEdit }) => [
  {
    title: "مهندس",
    dataIndex: "fullName",
    key: "fullName",
    width: 240,
    render: (text, record) => (
      <Space align="center" size={12}>
        <Avatar
          size={44}
          style={{
            background: "linear-gradient(135deg, #1890ff 0%, #096dd9 100%)",
            fontWeight: 600,
          }}
        >
          {text?.charAt(0) || "؟"}
        </Avatar>
        
        <div>
          <div style={{ fontWeight: 600, color: "#1f2937" }}>{text || "بدون نام"}</div>
          <div style={{ color: "#6b7280", fontSize: 12 }}>
            <IdcardOutlined style={{ marginLeft: 4 }} />
            {record.naCode || "-"}
          </div>
        </div>
      </Space>
    ),
  },
  {
    title: "موبایل",
    dataIndex: "cellPhone",
    key: "cellPhone",
    width: 130,
    render: text => (
      <span style={{ direction: "ltr", fontFamily: "monospace" }}>
        <PhoneOutlined style={{ marginLeft: 6, color: "#9ca3af" }} />
        {text || "-"}
      </span>
    ),
  },
  {
    title: "پایه/ضریب",
    key: "grade",
    width: 140,
    render: record => (
      <Space size={4} direction="vertical">
        <Tag color="blue" style={{ borderRadius: 6 }}>
          {record.engineerGradeTypeName || "-"}
        </Tag>
        <Tag color="purple" style={{ borderRadius: 6 }}>
          {record.factor || "-"}
        </Tag>
      </Space>
    ),
  },
  {
    title: "شماره حساب",
    dataIndex: "bankAccountNumber",
    key: "bankAccountNumber",
    width: 160,
    render: (text, record) => (
      <Space size={4} direction="vertical">
        <span style={{ fontFamily: "monospace" }}>{text || "-"}</span>
        {record.bankAccountBlocked && (
          <Tag color="red" style={{ fontSize: 10, borderRadius: 6 }}>
            مسدود
          </Tag>
        )}
      </Space>
    ),
  },
  {
    title: "اعتبار اولیه",
    dataIndex: "defaultQuota",
    key: "defaultQuota",
    width: 140,
    render: value => (
      <NumberFormat
        displayType="text"
        value={value}
        thousandSeparator
        suffix=" ریال"
        style={{ fontSize: 12, color: "#52c41a", fontWeight: 500 }}
      />
    ),
  },
  {
    title: "شهر",
    key: "city",
    width: 140,
    render: record => (
      <span>
        <EnvironmentOutlined style={{ marginLeft: 4, color: "#faad14" }} />
        {record.idSection > 0 ? GetCityWithSection(record.idSection) : "-"}
      </span>
    ),
  },
  {
    title: "تاریخ اعتبار",
    dataIndex: "solarCreditDate",
    key: "solarCreditDate",
    width: 140,
    render: text => (
      <Tag color="geekblue" style={{ borderRadius: 6 }}>
        <CalendarOutlined style={{ marginLeft: 4 }} />
        {text || "-"}
      </Tag>
    ),
  },
  {
    title: "وضعیت",
    key: "status",
    width: 140,
    render: record => (
      <Space size={6}>
        <Tooltip title={record.inactiveDes}>
          <Tag color={record.inactive ? "red" : "green"} style={{ borderRadius: 6 }}>
            {record.inactive ? "غیرفعال" : "فعال"}
          </Tag>
        </Tooltip>
        <Switch
          size="small"
          disabled
          checked={!record.inactive}
          checkedChildren={<CheckCircleOutlined />}
          unCheckedChildren={<CloseCircleOutlined />}
        />
      </Space>
    ),
  },
  {
    title: "فایل‌ها",
    key: "files",
    width: 140,
    align: "center",
    render: record => (
      <Space>
        {renderEditEngHistoryButton(record, { props })}
        {renderFileButton(record, { props })}
      </Space>
    ),
  },
  {
    title: "عملیات",
    key: "actions",
    width: 120,
    align: "center",
    render: record => renderEditButton(record, { props, handleEdit }),
  },
]
